// Public marketing-form email via the send-public-email Edge Function.
// The function keeps the recipient server-side; this client only supplies form
// details. It is safe to call while signed out.
import { supabase } from '../integrations/supabase/client';

export type EmpApplicationPayload = {
  formType: 'emp-application';
  fullName: string;
  email: string;
  phone: string;
  country: string;
  state: string;
  city: string;
  address?: string;
  companyName: string;
  businessType: string;
  yearsInExport: string;
  products: string;
  targetMarket: string;
  challenges: string;
  availability: string;
  investmentReadiness: string;
  whySelect: string;
  website?: string;
};

export type WhatsappRegistrationPayload = {
  formType: 'whatsapp-registration';
  fullName: string;
  email: string;
  phone: string;
  whatsapp: string;
  organization?: string;
  courseTitle: string;
  coursePrice?: string;
  website?: string;
};

export type PublicFormPayload = EmpApplicationPayload | WhatsappRegistrationPayload;

export async function sendPublicFormEmail(payload: PublicFormPayload) {
  const { data, error } = await supabase.functions.invoke('send-public-email', { body: payload });
  if (error) throw new Error('Your message could not be sent. Please try again.');
  if (!data?.ok) throw new Error(data?.message || 'Your message could not be sent. Please try again.');
  return data as { ok: true; id: string | null };
}
